export { default as Tooltip, type TooltipProps } from './Tooltip';
